import React from 'react'
import injectSheet from 'react-jss'

const Image = (props) => {
  const {
    alt,
    classes,
    fit,
    fullPath,
    src,
  } = props

  return (
    <div className={classes.imageContainer}>
      <img className={classes.image} src={`${!fullPath ? process.env.REACT_APP_BASE_PATH + src : fullPath}`} alt={alt} style={{ objectFit: fit || 'contain' }} />
    </div>
  )
}

const styles = () => ({
  imageContainer: {
    width: '100%',
    height: '100%',
  },
  image: {
    width: '100%',
    height: '100%',
  },
})

export default injectSheet(styles)(Image)



// WEBPACK FOOTER //
// ./src/modules/core/components/image.jsx